import React from 'react'
import './App.css';
import { ThemeProvider, Container, Grid, useTheme, useMediaQuery} from '@material-ui/core'
import useStyles from './Styles'
import SideContent from './component/SideContent'
import MainContent from './component/MainContent'

function App() {
  const useStyle = useStyles();
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <ThemeProvider>
        <Container className={useStyle.Container} maxWidth='xl'>
          <Container maxWidth='md'>
            <Grid container spacing={1}>
              <Grid item sm={3} xs={12}>

                <SideContent />

              </Grid>
              <Grid item sm={9} xs={12}>
                <MainContent />
              </Grid>
            </Grid>
          </Container>
        </Container>
    </ThemeProvider>
  );
}

export default App;
